import * as React from 'react';
const SvgPortal = (props) => (
  <svg viewBox="0 0 134 112" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.47 30.677V2H122.24v23.001M48.545 94.84H12.47V79.792M122.24 74.962v19.879H92.043M12.47 20.949H122.24M127.399 31.842h-30.09c-2.541 0-4.601 2.116-4.601 4.725v25.894c0 2.61 2.06 4.725 4.6 4.725H127.4c2.541 0 4.601-2.115 4.601-4.725V36.567c0-2.61-2.06-4.725-4.601-4.725Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m93.917 65.824 11.289-12.692a3.502 3.502 0 0 1 5.101-.175l14.345 14.13M105.334 36.868c0 4.025-3.179 7.29-7.098 7.29M118.07 51.169l3.611-3.79a3.498 3.498 0 0 1 4.76-.312L132 51.579M10.376 37.524h27.593c4.622 0 8.376 3.855 8.376 8.602v17.172c0 4.746-3.754 8.602-8.376 8.602H10.376C5.754 71.9 2 68.044 2 63.298V46.126c0-4.747 3.754-8.602 8.376-8.602Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.154 53.766c.708.421.708 1.471 0 1.887l-6.038 3.582-6.038 3.582c-.709.42-1.593-.104-1.593-.946V47.548c0-.842.884-1.361 1.593-.946l6.038 3.582 6.038 3.582ZM84.417 77.653v22.585a3.854 3.854 0 0 1-1.08 2.686l-5.81 5.966a3.65 3.65 0 0 1-2.615 1.11h-14.61c-1.966 0-3.558-1.635-3.558-3.653V77.653c0-2.018 1.592-3.653 3.557-3.653h20.56c1.964 0 3.556 1.635 3.556 3.653ZM70.583 96.739v-15.16"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m77.5 83.947-1.384-2.368h-11.07l-1.385 2.368M20.482 11.532h5.059"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.03 11.532h12.726"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="15.93 15.93"
    />
    <path
      d="M50.993 11.532h5.059"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgPortal;
